
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"icon",attrs:{"fill":"none","stroke":"#abadb0","stroke-linecap":"round","stroke-miterlimit":"50","stroke-width":"2","d":"M14 2L2 14M2 2l12 12"}})])
          )
        }
      }
    